<template>
    <div>
        <div class="row">
            <div class="column small-8">
                <PageTitle title="Prijswijzigingen" :description="description" :total="total" :loading="loading" />
            </div>
            <div class="column small-4 text-right">
                <b-tooltip :label="hideSensitiveData ? 'Toon gevoelige data' : 'Verberg gevoelige data'" position="is-left">
                    <b-button :type="hideSensitiveData ? 'is-success' : 'is-danger'" :icon-right="hideSensitiveData ? 'eye' : 'eye-slash'" @click="$store.dispatch('toggleSensitiveData')"></b-button>
                </b-tooltip>
                <b-button type="is-dark" tag="router-link" :to="{ name: 'ContractsPriceChangesRecord', params: {id: 'nieuw'} }">Nieuw</b-button>
            </div>
        </div>

        <div class="row">
            <div class="column">
                <ContractsPriceChangeTable
                    ref="ContractsPriceChangeTable"
                    @passTotal="passTotal"
                    @passLoading="passLoading"
                />
            </div>
        </div>
    </div>
</template>

<script>
import ContractsPriceChangeTable from './ContractsPriceChangeTable'
// import paramsMixin from '@/mixins/paramsMixin'

export default {
    name: 'ContractPriceChanges',

    components: {
        ContractsPriceChangeTable
    },

    // mixins: [paramsMixin],

    data() {
        return {
            total: null,
            loading: false
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        hideSensitiveData() {
            return this.$store.state.hideSensitiveData
        },
        description() {
            if (this.user.organisation_type == 'box') {
                return 'Hier is het mogelijk om periodieke prijsverhogingen toe te passen op boxen binnen contracten.'
            }

            return false
        }
    },

    methods: {
        passTotal(total) {
            this.total = total
        },
        passLoading(loading) {
            this.loading = loading
        }
    },

    mounted() {
        // Check if in this session a query is saved (last success) else use default sorting.
        this.$refs['ContractsPriceChangeTable'].getSearchParams().then(() => {
            this.$refs['ContractsPriceChangeTable'].loadAsyncData()
        })
    }
}
</script>
